import React from 'react';
import { Link } from 'react-router-dom';

import './ReadMoreButton.css';

const ReadMoreButton = ({ to }) => {
  return (
    <div className='read-more-btn-container'>
      <Link to={to} className='read-more-btn'>
        Read More
      </Link>
    </div>
  );
};

export default ReadMoreButton;
